module.exports = __webpack_public_path__ + "img/background.876b9930.png";